import Text15 from './Text15'
export default Text15
